import { docCompareEndpoint } from '~/api/def/endpoints/docCompare/docCompareEndpoint';
import { BqResponse } from '~/api/def/endpoints/types';
import { getExecEndpoint } from '~/api/service/getExecEndpoint';
import { docChunkFinderApi } from '~/api/def/servers/defaultServer';

const docCompareChunkFinderEndpoint = {
  server: docChunkFinderApi,
  path: '',
  description: '',
};

const endpointDocCompareChunkFinderPostExec =
  getExecEndpoint<DocChunkFinderEndpointDef>(docCompareChunkFinderEndpoint);
export const docCompareChunkFinderEndpointPOST = async (
  payload: DocCompareChunkFinderRequest,
) => {
  const searchParams = new URLSearchParams();

  const params: Record<string, string | undefined> = {
    query_text: payload.query_text,
    number_of_chunks: payload.number_of_chunks?.toString(),
    document_id: payload.document_id,
    use_hyde: payload.use_hyde?.toString() || 'false',
  };

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      searchParams.set(key, value);
    }
  });

  return endpointDocCompareChunkFinderPostExec<'POST'>({
    method: 'POST',
    urlExtra: `chunk-finder?${searchParams.toString()}`,
    ...(payload.large_query_text && {
      payload: {
        text: payload.large_query_text,
      },
    }),
  });
};
export interface DocCompareChunkFinderChunk {
  id: string;
  document_id: string;
  document_name?: string;
  original_file_name?: string;
  client_id: string;
  text: string;
  text_chunk?: string;
  document_type?: string;
  investor_name?: string;
  fund_id?: string | number;
  type?: string;
  bbox_page_start: number;
  bbox_page_end: number;
  bbox_x1: number;
  bbox_y1: number;
  bbox_x2: number;
  bbox_y2: number;
}

export type DocCompareChunkFinderResponse = BqResponse<{
  data: DocCompareChunkFinderChunk[];
}>;

export type DocChunkFinderApiType = {
  text?: string;
};

export interface DocChunkFinderEndpointDef {
  endpoint: typeof docCompareEndpoint;
  methods: {
    POST: {
      response: DocCompareChunkFinderResponse;
      payload: DocChunkFinderApiType;
    };
  };
}

export interface DocCompareChunkFinderRequest {
  query_text: string;
  number_of_chunks: number;
  document_id?: string;
  use_hyde?: boolean;
  large_query_text?: string;
}
